import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaEnvelope,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaTiktok,
} from "react-icons/fa";
import "./contact.css";
import BackButton from "./BackButton";

const ContactUs = () => {
  return (
    
    <div className="contact-container">
        <BackButton />
      
      <h1 className="contact-title">Contact Us</h1>

      <p className="contact-description">
        Have questions or want to get in touch? Connect with us through our social media platforms or use the contact details below. We're always happy to hear from you!
      </p>

      <div className="social-icons">
        <a href="https://www.facebook.com/share/1AZqb8zUWr/" target="_blank" rel="noopener noreferrer">
          <FaFacebookF />
        </a>
        
        <a href="https://www.tiktok.com/@aubattle.official?_t=ZS-8whTvwHfR1W&_r=1" target="_blank" rel="noopener noreferrer">
          <FaTiktok />
        </a>
     
        <a href="https://www.instagram.com/supaubatle?igsh=Nmpyenl3OTRzNG5v" target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </a>
      </div>

      <div className="contact-info-box">
        <div className="info-item">
          <FaEnvelope className="icon yellow" />
          <span>supaubatle@gmail.com</span>
        </div>
        <div className="info-item">
          <FaWhatsapp className="icon green" />
          <span>+92 3160125118</span>
        </div>
        <div className="info-item">
          <FaMapMarkerAlt className="icon red" />
          <span>Karachi, Pakistan</span>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
